import {defineWebComponent} from "../webcomponents-utils";
import {WlShowMore} from "./showMore.component";

export * from './showMore.component';
export default WlShowMore;

defineWebComponent('wl-show-more', WlShowMore);
